// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"66f47c92","703":"2e85056c"}[chunkId] + ".chunk.js";
};